import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--delete" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl c-ttl" }, "退会 確認", -1)
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-messages" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "c-message" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "c-message__txt c-message__txt--primary" }, [
      /*#__PURE__*/_createElementVNode("i"),
      /*#__PURE__*/_createElementVNode("span", null, "退会すると、集英社IDを使⽤して連携サービスがご利⽤できなくなります。退会しますか？")
    ])
  ])
], -1)
const _hoisted_5 = { class: "p-mypage__field-container" }
const _hoisted_6 = {
  key: 0,
  class: "p-errors"
}
const _hoisted_7 = { class: "c-error" }
const _hoisted_8 = { class: "p-fields p-fields--confirm" }
const _hoisted_9 = { class: "c-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "退会理由", -1)
const _hoisted_11 = {
  class: "c-field__body",
  style: {"flex-direction":"column"}
}
const _hoisted_12 = { class: "c-field has-submit has-mt" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "退会する", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "キャンセル", -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.errorMsgRef)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errorMsgRef), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("fieldset", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.leaveNote.leaveNote1 || '').split('\n'), (line, idx) => {
                return (_openBlock(), _createElementBlock("p", { key: idx }, _toDisplayString(line), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "c-btn is-submit",
              disabled: _ctx.isDeterringRef,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.withdrawal, this)))
            }, _hoisted_15, 8, _hoisted_13),
            _createElementVNode("button", {
              class: "c-btn c-btn--outline",
              disabled: _ctx.isDeterringRef,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, _hoisted_18, 8, _hoisted_16)
          ])
        ])
      ])
    ])
  ], 64))
}